import React from "react";
const rowToPageIndices = (rowIndices, pageSize) => {
    const set = new Set();
    for (const rowIndex of rowIndices) {
        const index = Math.max(rowIndex, 0);
        set.add(Math.floor(index / pageSize));
    }
    return Array.from(set);
};
const pageToRowIndices = (pageIndex, pageSize) => {
    const startIndex = (pageIndex * pageSize);
    const stopIndex = startIndex + pageSize - 1;
    return [startIndex, stopIndex];
};
export const useInfiniteLoader = (props) => {
    const { isRowLoaded, loadMoreRows, startIndex, stopIndex, pageSize, hasMoreRows } = props;
    const pageMap = React.useRef(new Map());
    React.useEffect(() => {
        if (!isRowLoaded)
            return;
        if (!loadMoreRows)
            return;
        if (!hasMoreRows)
            return;
        const pageIndices = rowToPageIndices([startIndex, stopIndex], pageSize);
        for (const pageIndex of pageIndices) {
            const [pageRowStartIndex, pageRowStopIndex] = pageToRowIndices(pageIndex, pageSize);
            if (isRowLoaded(pageRowStartIndex) && isRowLoaded(pageRowStopIndex)) {
                continue;
            }
            if (pageMap.current.has(pageIndex)) {
                continue;
            }
            const abortController = new AbortController();
            pageMap.current.set(pageIndex, abortController);
            loadMoreRows({
                rowStartIndex: pageRowStartIndex,
                rowStopIndex: pageRowStopIndex,
                abortController
            }).then(x => {
                pageMap.current.delete(pageIndex);
                return x;
            }).catch(() => {
                pageMap.current.delete(pageIndex);
            });
            break;
        }
    }, [hasMoreRows, isRowLoaded, loadMoreRows, pageSize, startIndex, stopIndex]);
};
